<template>
  <section class="layout-grid__item">
    <figure class="layout-grid__figure" @click="$global.workItem = item">
      <div class="layout-grid__image" :style="imageStyle"/>
    </figure>

    <h3 class="layout-grid__title">{{ item.title }}</h3>
    <p>{{ item.subtitle }}</p>
  </section>
</template>

<script>
export default {
  name: 'WorkItem',
  props: {
    item: { type: Object, required: true }
  },
  computed: {
    imageStyle() {
      return { backgroundImage: `url('${this.item.images[0]}')` }
    }
  }
}
</script>
